module.exports = __webpack_public_path__ + "static/media/400392_01.13a6a9bc.png";